// extracted by mini-css-extract-plugin
export default {"wrapper":"Story_wrapper__Iqb7C","container":"Story_container__pPDau"};